import cash from "cash-dom";

(function () {
    if (cash("#availability").length) {
        cash('.avail__btn').each((index, ele) => {
            ele.addEventListener('click', () => {
                updateAvailability(ele)
            });
        })
        cash('.avail__info').each((index, ele) => {
            ele.addEventListener('input', () => {
                updateNote(ele)
            });
        })
    }

    function updateAvailability(element) {
        let data = {
            type: element.dataset.type,
            day: element.dataset.day,
        }
        if (element.dataset.id) {
            data['id'] = element.dataset.id
        }
        postAjax('/plan/api/availability/update', data, function (data) {
            data = JSON.parse(data);
            updateButtons(data.day, data.available, data.id);
            updateStats(data.day, data.available);
        })

    }

    function updateNote(element) {
        let data = {
            note: element.value,
        }
        if (element.dataset.id) {
            data['id'] = element.dataset.id
        }
        postAjax('/plan/api/availability/update/note', data, function () {
        })
    }

    function updateButtons(day, status, id) {
        cash(`.avail__btn[data-day="${day}"]`).each((index, ele) => {
            ele.classList.remove('btn-success-soft', 'btn-secondary-soft', 'btn-danger-soft');
            ele.classList.remove('btn-success', 'btn-secondary', 'btn-danger');
            let note_ele = cash(`.avail__info[data-day="${day}"]`)[0];

            if (status != null) {
                ele.dataset.id = id;
                note_ele.dataset.id = id;
                note_ele.removeAttribute('disabled');
            } else {
                ele.dataset.id = '';
                note_ele.setAttribute('disabled', '');
            }

            switch (status) {
                case true:
                    if (ele.dataset.type === 'True') {
                        ele.classList.add('btn-success');
                    }
                    break
                case false:
                    if (ele.dataset.type === 'False') {
                        ele.classList.add('btn-danger');
                    }
                    break;
                case null:
                    if (ele.dataset.type === 'None') {
                        ele.classList.remove('btn-secondary-soft');
                    }
                    note_ele.value = '';

            }
        });

        switch (status) {
            case true:
                cash(`.avail__btn[data-day="${day}"][data-type="False"]`).addClass('btn-danger-soft')
                cash(`.avail__btn[data-day="${day}"][data-type="None"]`).addClass('btn-secondary-soft')
                break
            case false:
                cash(`.avail__btn[data-day="${day}"][data-type="True"]`).addClass('btn-success-soft')
                cash(`.avail__btn[data-day="${day}"][data-type="None"]`).addClass('btn-secondary-soft')
                break;
            case null:
                cash(`.avail__btn[data-day="${day}"][data-type="True"]`).addClass('btn-success-soft')
                cash(`.avail__btn[data-day="${day}"][data-type="False"]`).addClass('btn-danger-soft')
                break;

        }
    }

    function updateStats(day, available) {
        let selector = cash(`div[data-day="${day}"]`).find('.avail__overview');

        selector.children().each((index, ele) => {
            ele.innerText = parseInt(ele.dataset.other).toString();
        })

        switch (available) {
            case true: {
                let span_true = selector.find('[data-type=True]')[0];
                span_true.innerText = (parseInt(span_true.dataset.other) + 1).toString()
                break
            }
            case false: {
                let span_false = selector.find('[data-type=False]')[0];
                span_false.innerText = (parseInt(span_false.dataset.other) + 1).toString()
                break;
            }

            case null: {
                let span_undef = selector.find('[data-type=None]')[0];
                span_undef.innerText = (parseInt(span_undef.dataset.other) + 1).toString()
                break;
            }
        }
    }

    function postAjax(url, data, success) {
        let params = typeof data == 'string' ? data : Object.keys(data).map(
            function (k) {
                return encodeURIComponent(k) + '=' + encodeURIComponent(data[k])
            }
        ).join('&');

        let xhr = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject("Microsoft.XMLHTTP");
        xhr.open('POST', url);
        xhr.onreadystatechange = function () {
            if (xhr.readyState > 3 && xhr.status === 200) {
                success(xhr.responseText);
            }
        };
        xhr.setRequestHeader('X-CSRFToken', document.getElementsByName('csrfmiddlewaretoken')[0].value);
        xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
        xhr.send(params);
        return xhr;
    }
})();